import { adyenService } from '@/api/adyen.service';
import { registerPlugin, type Plugin } from '@capacitor/core';

export interface IAdyenPlugin extends Plugin {
  openDeviceSelection(): Promise<void>;
  initPosSession(): Promise<void>;
  getMethods(): Promise<{
    tapToPay: boolean;
    cardReader: boolean;
  }>;
  initializePayment({
    amount,
    currency,
    adyenData,
    method,
  }: {
    amount: number;
    currency: string;
    reference: string;
    adyenData: {
      metadata: Record<string, string>;
      shopperReference: string | undefined;
      shopperEmail: string | undefined;
      recurringProcessingModel?: 'UnscheduledCardOnFile';
      shopperStatement?: string;
      tenderOption?: string;
      additionalData?: {
        manualCapture?: 'true' | 'false';
        authorisationType: 'PreAuth' | 'FinalAuth';
      };
    };
    method: 'cardReader' | 'tapToPay';
  }): Promise<any>;
  resetSession(): Promise<void>;
  needsTapToPayLinking(): Promise<{
    needsTapToPayLinking: boolean;
  }>;
  linkTapToPay(): Promise<void>;
}

/**
 * Booking the next POS session is opened for, and its legal entity. Each legal entity has its own
 * Adyen merchant account; the backend takes it from the booking, so the session follows the
 * booking being charged.
 */
export const posSessionTarget: { bookingId?: string; legalEntityId?: string } = {};

(window as any).getAdyenSdkData = async (setupToken: string) => {
  return await adyenService
    .posSession(setupToken, posSessionTarget.bookingId)
    .then((response) => {
      return response.sdkData;
    })
    .catch(() => {
      return null;
    });
};

const AdyenPlugin = registerPlugin<IAdyenPlugin>('Adyen');
export default AdyenPlugin;
